import {DefaultPortModel} from 'storm-react-diagrams';
import FlowDiagramLinkModel from '../__link/flowDiagram__link_model';

class FlowDiagramPortModel extends DefaultPortModel {
    createLinkModel() {
        return new FlowDiagramLinkModel();
    }
}

export default FlowDiagramPortModel